export const DEFAULT_INTERVAL = 10000;
